module.exports = __webpack_public_path__ + "static/media/cvm-health-logo_300x300.88a11258.webp";